import React from 'react'

import { FieldArray } from 'formik'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import NUMMIN from '../../../business-rules/NumMinMax/NumMin'

import NUMMAX from '../../../business-rules/NumMinMax/NumMax'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import ClienteService from '../../../business-api/ClienteService'

import {
    adicionaNaoInformar
} from '../../../business-components/Array/Array'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem1,
    GridItem1xs3,
    GridItem2xs6,
    GridItem3xs6,
    GridItem4xs8,
    GridItem9xs5,
    GridItem10xs12,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDados,
    CardGridDivHeaderEntradaDados,
    CardGridDivBodyEntradaDados,
    CardGridEntradaDadosHeaderBodyDivider,
} from '../../../business-components/Card/Card'

import { 
    MuiPickersUtilsProviderPadrao,
    KeyboardDatePickerPadrao,
} from '../../../business-components/MuiPickers/MuiPickers'

import {
    TextValidatorText,
    TextValidatorTextDestaque,
    TextValidatorTextMultiline,
    TextValidatorNumber,
    TextValidatorValor,
} from '../../../business-components/TextValidator/TextValidator'

import {
    TextFieldTextSelect,
    TextFieldTextSelectRequired,
    TextFieldNumberSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import familiaresList from '../../../business-rules/List/familiaresList'

import tipoPeriodicidadeList from '../../../business-rules/List/tipoPeriodicidadeList'

import tipoFormaPagtoPremioList from '../../../business-rules/List/tipoFormaPagtoPremioList'

import seguradoraList from '../../../business-rules/List/SeguroVida/seguradoraList'

import statusApoliceList from '../../../business-rules/List/SeguroVida/statusApoliceList'

import simNaoList from '../../../business-rules/List/simNaoList'

import {
    IconButtonClearEntradaDados
} from '../../../business-components/IconButton/IconButton'

import {
    ButtonIncluirLinha,
    ButtonVisualizarPDFLeft,
} from '../../../business-components/Button/Button'

import {
    CustomizedDialogsViewPDF,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    getArquivoConteudo,
} from '../../arquivo/ArquivoService'

import {
    obtemArquivoApolice,
} from '../acompanhamento-form/AcompanhamentoServiceArquivo'

import {
    getObterPDFBase64FromUrl,
} from '../integracaoClienteArquivo-list/IntegracaoClienteArquivoService'

import {
    incrementaContSeguroVidaApolice,
    processaValoresDefaultIniciaisSeguroVidaApolice,
    processaAlteracaoSeguroVidaApoliceSeguradora,
} from './SeguroVidaServiceSeguroVidaApolice'

import {
    incluiSeguroVidaCoberturaDefault,
    excluirCoberturas,
} from './SeguroVidaServiceSeguroVidaCobertura'

import SeguroVidaFormSeguroVidaCobertura from './SeguroVidaFormSeguroVidaCobertura'


const SeguroVidaFormSeguroVidaApolice = ({ variaveisGlobais, values, handleChange, setFieldValue, vars, arquivoList,
    popupApolice }) => {

    return (
        <FieldArray name="seguroVidaApolice">
            {(arrayHelpers) => (
                <DivForm>
                    <GridContainer>
                        {values.seguroVidaApolice?.map((item, ind) => {

                            processaValoresDefaultIniciaisSeguroVidaApolice(item)

                            const arquivoApolice = obtemArquivoApolice(arquivoList, item.numeroApolice)
                            
                            return item.familiar === Number.parseInt(values.familiarSeguroVida)
                            ? (
                                <GridItem12
                                    key={ind}
                                >
                                    {!popupApolice && (
                                        <CardGridEntradaDados
                                            className='mb-5'
                                        >
                                            <GridContainer>
                                                <GridItem12
                                                    className='mt-2'
                                                    align='center'
                                                >
                                                    <h1>
                                                        {LABEL.apolice}
                                                    </h1>
                                                </GridItem12>
                                            </GridContainer>
                                        </CardGridEntradaDados>
                                    )}
                                    
                                    <CardGridEntradaDados>
                                        <CardGridDivHeaderEntradaDados>
                                            <GridContainer>
                                                <GridItem2xs6>
                                                    <TextValidatorTextDestaque
                                                        name={`seguroVidaApolice[${ind}].numeroApolice`}
                                                        //placeholder={LABEL.numeroApolice}
                                                        label={LABEL.numeroApolice}
                                                        value={item.numeroApolice|| ''}
                                                        onChange={handleChange}
                                                        tamMax={TAMMAX.numeroApolice}
                                                        disabled={item.idReceitaMensal > 0}
                                                    />
                                                </GridItem2xs6>

                                                <GridItem9xs5   
                                                    className='mt-4'
                                                >
                                                    {arquivoApolice && (
                                                        <CustomizedDialogsViewPDF
                                                            maxWidth='xl'
                                                            align='left'
                                                            popupTitle={arquivoApolice.nomeArquivo}
                                                            PopupButton={ButtonVisualizarPDFLeft}
                                                            carregarPDF={async () => {
                                                                const arquivoArquivoAcessoDTO =
                                                                    await getArquivoConteudo(variaveisGlobais,
                                                                        ClienteService.obterUsuarioClienteSelecionado(
                                                                            variaveisGlobais), arquivoApolice.idArquivo)
                        
                                                                return arquivoArquivoAcessoDTO.conteudo
                                                            }}
                                                            //pdfFile={pdf}
                                                        />
                                                    )}
                                                    {!arquivoApolice && item.urlApolice && (
                                                        <CustomizedDialogsViewPDF
                                                            maxWidth='xl'
                                                            align='left'
                                                            popupTitle={item.urlApolice}
                                                            PopupButton={ButtonVisualizarPDFLeft}
                                                            carregarPDF={async () => {
                                                                const { PDFBase64/*, mensagemErroPDFBase64*/ } =
                                                                    await getObterPDFBase64FromUrl(variaveisGlobais,
                                                                        item.urlApolice,
                                                                            ('' + pesquisaList(familiaresList(values),
                                                                                item.familiar).cpf).substring(0, 5))
                        
                                                                return PDFBase64
                                                            }}
                                                            //pdfFile={pdf}
                                                        />
                                                    )}
                                                </GridItem9xs5>

                                                <GridItem1>
                                                    <IconButtonClearEntradaDados
                                                        onClick={() => {
                                                            excluirCoberturas(values, item.id)

                                                            arrayHelpers.remove(ind)
                                                        }}
                                                        style={{
                                                            display:
                                                                !item.idReceitaMensal
                                                                    ? "block"
                                                                    : "none"
                                                        }}
                                                    />
                                                </GridItem1>
                                            </GridContainer>
                                        </CardGridDivHeaderEntradaDados>

                                        <CardGridDivBodyEntradaDados>
                                            <GridContainer>
                                                <GridItem2xs6>
                                                    <TextFieldNumberSelect
                                                        name={`seguroVidaApolice[${ind}].seguradora`}
                                                        label={LABEL.seguradora}
                                                        value={item.seguradora || ''}
                                                        onChange={handleChange}
                                                        list={seguradoraList()}
                                                        onBlur={processaAlteracaoSeguroVidaApoliceSeguradora(item)}
                                                        disabled={item.idReceitaMensal > 0}
                                                    />
                                                </GridItem2xs6>

                                                <GridItem2xs6
                                                    style={{
                                                        display:
                                                            item.seguradora === HARDCODE.idSeguradoraOutras 
                                                                ? "block"
                                                                : "none"
                                                    }}
                                                >
                                                    <TextValidatorText
                                                        name={`seguroVidaApolice[${ind}].seguradoraOutras`}
                                                        label={LABEL.seguradoraOutras}
                                                        value={item.seguradoraOutras || ''}
                                                        onChange={handleChange}
                                                        tamMax={TAMMAX.seguradoraOutras}
                                                        disabled={item.idReceitaMensal > 0}
                                                    />
                                                </GridItem2xs6>

                                                <GridItem2xs6>
                                                    <MuiPickersUtilsProviderPadrao>
                                                        <KeyboardDatePickerPadrao
                                                            name={`seguroVidaApolice[${ind}].dataEmissao`}
                                                            label={LABEL.dataEmissao}
                                                            value={item.dataEmissao}
                                                            onChange={(date) => {
                                                                setFieldValue(
                                                                    `seguroVidaApolice[${ind}].dataEmissao`,
                                                                    date,
                                                                )}
                                                            }
                                                            disabled={item.idReceitaMensal > 0}
                                                        />
                                                    </MuiPickersUtilsProviderPadrao>
                                                </GridItem2xs6>

                                                <GridItem2xs6>
                                                    <TextFieldTextSelectRequired
                                                        name={`seguroVidaApolice[${ind}].tipoPeriodicidadePagtoPremio`}
                                                        label={LABEL.tipoPeriodicidadePagtoPremio}
                                                        value={item.tipoPeriodicidadePagtoPremio || ''}
                                                        onChange={handleChange}
                                                        list={tipoPeriodicidadeList(false, true, false)}
                                                        disabled={item.idReceitaMensal > 0}
                                                    />
                                                </GridItem2xs6>

                                                {item.tipoFormaPagtoPremio && (
                                                    <GridItem2xs6>
                                                        <TextFieldTextSelect
                                                            name={`seguroVidaApolice[${ind}].tipoFormaPagtoPremio`}
                                                            label={LABEL.tipoFormaPagto}
                                                            value={item.tipoFormaPagtoPremio || ''}
                                                            onChange={handleChange}
                                                            list={tipoFormaPagtoPremioList}
                                                        />
                                                    </GridItem2xs6>
                                                )}

                                                {item.prazoPagto && (
                                                    <GridItem1xs3>
                                                        <TextValidatorNumber
                                                            name={`seguroVidaApolice[${ind}].prazoPagto`}
                                                            label={LABEL.prazoPagto}
                                                            value={item.prazoPagto === 0 ? 0 : item.prazoPagto || ''}
                                                            onChange={handleChange}
                                                            numMin={NUMMIN.anos}
                                                            numMax={NUMMAX.anos}
                                                        />
                                                    </GridItem1xs3>
                                                )}

                                                 {item.diaVencimento && (
                                                    <GridItem1xs3>
                                                        <TextValidatorNumber
                                                            name={`seguroVidaApolice[${ind}].diaVencimento`}
                                                            label={LABEL.diaVencimento}
                                                            value={item.diaVencimento === 0 ? 0 : item.diaVencimento || ''}
                                                            onChange={handleChange}
                                                            numMin={NUMMIN.dia}
                                                            numMax={NUMMAX.dia}
                                                        />
                                                    </GridItem1xs3>
                                                )}

                                                {item.valorPremioAnualizado && (
                                                    <GridItem2xs6>
                                                        <TextValidatorValor
                                                            name={`seguroVidaApolice[${ind}].valorPremioAnualizado`}
                                                            label={LABEL.valorPremioAnualizado}
                                                            value={item.valorPremioAnualizado === 0 ? 0 : item.valorPremioAnualizado || ''}
                                                            onChange={handleChange}
                                                        />
                                                    </GridItem2xs6>
                                                )}
                                                
                                                <GridItem2xs6>
                                                    <TextFieldTextSelect
                                                        name={`seguroVidaApolice[${ind}].statusApolice`}
                                                        label={LABEL.statusApolice}
                                                        value={item.statusApolice || ''}
                                                        onChange={handleChange}
                                                        list={statusApoliceList}
                                                        disabled={item.idReceitaMensal > 0}
                                                    />
                                                </GridItem2xs6>

                                                {item.numeroCotacao && (
                                                    <GridItem2xs6>
                                                        <TextValidatorText
                                                            name={`seguroVidaApolice[${ind}].numeroCotacao`}
                                                            label={LABEL.numeroCotacao}
                                                            value={item.numeroCotacao || ''}
                                                            onChange={handleChange}
                                                            tamMax={TAMMAX.numeroCotacao}
                                                            disabled={item.idReceitaMensal > 0}
                                                        />
                                                    </GridItem2xs6>
                                                )}

                                                <GridItem2xs6>
                                                    <TextValidatorText
                                                        name={`seguroVidaApolice[${ind}].numeroProposta`}
                                                        label={LABEL.numeroProposta}
                                                        value={item.numeroProposta || ''}
                                                        onChange={handleChange}
                                                        tamMax={TAMMAX.numeroProposta}
                                                        disabled={item.idReceitaMensal > 0}
                                                    />
                                                </GridItem2xs6>

                                                {item.dataCancelamento && (
                                                    <GridItem2xs6>
                                                        <MuiPickersUtilsProviderPadrao>
                                                            <KeyboardDatePickerPadrao
                                                                name={`seguroVidaApolice[${ind}].dataCancelamento`}
                                                                label={LABEL.dataCancelamento}
                                                                value={item.dataCancelamento}
                                                                onChange={(date) => {
                                                                    setFieldValue(
                                                                        `seguroVidaApolice[${ind}].dataCancelamento`,
                                                                        date,
                                                                    )}
                                                                }
                                                                disabled={item.idReceitaMensal > 0}
                                                            />
                                                        </MuiPickersUtilsProviderPadrao>
                                                    </GridItem2xs6>
                                                )}

                                                {item.motivoCancelamento && (
                                                    <GridItem4xs8>
                                                        <TextValidatorText
                                                            name={`seguroVidaApolice[${ind}].motivoCancelamento`}
                                                            label={LABEL.motivoCancelamento}
                                                            value={item.motivoCancelamento || ''}
                                                            onChange={handleChange}
                                                            tamMax={TAMMAX.motivoCancelamento}
                                                            disabled={item.idReceitaMensal > 0}
                                                        />
                                                    </GridItem4xs8>
                                                )}

                                                {vars.jsonConfiguracao.habilitarDivisaoComissaoSeguroVida &&
                                                vars.linhaPerfil.podeInformarDivisaoComissaoSeguroVida === 'S' && (
                                                    <>
                                                        <GridItem3xs6>
                                                            <TextFieldTextSelect
                                                                name={`seguroVidaApolice[${ind}].idCorretorSeguros`}
                                                                label={LABEL.idCorretorSeguros}
                                                                value={item.idCorretorSeguros || ''}
                                                                onChange={handleChange}
                                                                list={adicionaNaoInformar(vars.equipeList)}
                                                            />
                                                        </GridItem3xs6>

                                                        {item.idCorretorSeguros && (
                                                            <GridItem2xs6>
                                                                <TextValidatorNumber
                                                                    name={`seguroVidaApolice[${ind}].percDivisaoComissao`}
                                                                    label={LABEL.percDivisaoComissao}
                                                                    value={item.percDivisaoComissao === 0 ? 0 : item.percDivisaoComissao || ''}
                                                                    onChange={handleChange}
                                                                    numMin={NUMMIN.perc}
                                                                    numMax={NUMMAX.perc}
                                                                />
                                                            </GridItem2xs6>
                                                        )}

                                                        {item.percDivisaoComissao && item.percDivisaoComissao !== 100 && (
                                                            <GridItem3xs6>
                                                                <TextFieldTextSelect
                                                                    name={`seguroVidaApolice[${ind}].idCorretorSeguros2`}
                                                                    label={LABEL.idCorretorSeguros2}
                                                                    value={item.idCorretorSeguros2 || ''}
                                                                    onChange={handleChange}
                                                                    list={adicionaNaoInformar(vars.equipeList)}
                                                                />
                                                            </GridItem3xs6>
                                                        )}

                                                        <GridItem2xs6>
                                                            <TextValidatorText
                                                                name={`seguroVidaApolice[${ind}].codigoAgenteAssessorInvestimentos`}
                                                                label={LABEL.codigoAgenteAssessorInvestimentos}
                                                                value={item.codigoAgenteAssessorInvestimentos || ''}
                                                                onChange={handleChange}
                                                                tamMax={TAMMAX.codigoAgente}
                                                            />
                                                        </GridItem2xs6>
                                                    </>
                                                )}

                                            </GridContainer>

                                            {item.urlApolice && (
                                                <GridContainer>
                                                    <GridItem10xs12>
                                                        <TextValidatorText
                                                            name={`seguroVidaApolice[${ind}].urlApolice`}
                                                            label={LABEL.urlApolice}
                                                            value={item.urlApolice || ''}
                                                            onChange={handleChange}
                                                            tamMax={TAMMAX.url}
                                                            disabled={item.idReceitaMensal > 0}
                                                            notToUpperCase={true}
                                                        />
                                                    </GridItem10xs12>
                                                </GridContainer>
                                            )}

                                            <GridContainer>
                                                <GridItem10xs12>
                                                    <TextValidatorTextMultiline
                                                        name={`seguroVidaApolice[${ind}].observacao`}
                                                        label={LABEL.observacao}
                                                        value={item.observacao || ''}
                                                        onChange={handleChange}
                                                        tamMax={TAMMAX.observacao}
                                                        disabled={item.idReceitaMensal > 0}
                                                    />
                                                </GridItem10xs12>

                                                <GridItem2xs6>
                                                    <TextFieldTextSelect
                                                        name={`seguroVidaApolice[${ind}].producaoPropria`}
                                                        label={LABEL.producaoPropria}
                                                        value={item.producaoPropria || ''}
                                                        onChange={handleChange}
                                                        list={simNaoList}
                                                        disabled={item.idReceitaMensal > 0}
                                                    />
                                                </GridItem2xs6>
                                            </GridContainer>
                                        </CardGridDivBodyEntradaDados>
                                        
                                        <CardGridEntradaDadosHeaderBodyDivider
                                            title={LABEL.coberturas}
                                        >
                                            <SeguroVidaFormSeguroVidaCobertura
                                                idSeguroVidaApolice={item.id}
                                                idReceitaMensal={item.idReceitaMensal}
                                                integracao={item.integracao}
                                                values={values}
                                                handleChange={handleChange}
                                                setFieldValue={setFieldValue}
                                            />
                                        </CardGridEntradaDadosHeaderBodyDivider>
                                    </CardGridEntradaDados>
                                </GridItem12>
                            )
                            :
                            (
                                ''
                            )
                        })}
                    </GridContainer>

                    <ButtonIncluirLinha
                        label={LABEL.buttonIncluirSeguroVidaApolice} 
                        disabled={familiaresList(values).length === 0 || !values.familiarSeguroVida ? true : false}
                        onClick={() =>
                            {
                                incrementaContSeguroVidaApolice(values)
                                incluiSeguroVidaCoberturaDefault (values, values.contSeguroVidaApolice)
                                arrayHelpers.push({
                                    id: values.contSeguroVidaApolice,
                                    familiar: Number.parseInt(values.familiarSeguroVida),
                                })
                            }
                        }
                    />
                </DivForm>
            )}
        </FieldArray>
    )
}

export default SeguroVidaFormSeguroVidaApolice